import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class BaseURLInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const customAPI = localStorage.getItem('customAPI');
    if (customAPI) {
      try {
        const newURL = new URL(customAPI);
        let oldURL;

        if (req.url.includes('://')) {
          oldURL = new URL(req.url);
        } else {
          oldURL = new URL(req.url, 'http://dummy.com');
        }

        oldURL.host = newURL.host;
        oldURL.port = newURL.port;
        oldURL.protocol = newURL.protocol;
        const newReq = req.clone({ url: oldURL.toString() });
        return next.handle(newReq);
      } catch (e) {
        console.error(e);
        return next.handle(req);
      }
    } else {
      // default
      return next.handle(req);
    }
  }
}
